export const inventory = {
  title: 'Inventory Management',
  subtitle: 'Manage inventory and stock movements',
  filteredByProduct: 'Filtered by product',

  tab: {
    stock: 'Inventory',
    movements: 'Stock Movements',
    documents: 'Documents'
  },

  belowMinimum: 'Below Minimum',
  aboveMaximum: 'Above Maximum',
  outOfStock: 'Out of Stock',
  inStock: 'In Stock',
  allWarehouses: 'All Warehouses',
  onlyAvailable: 'Only Available',
  noItemsFound: 'No inventory items found',
  product: 'Product',
  warehouse: 'Warehouse',
  status: 'Status',
  quantity: 'Quantity',
  reserved: 'Reserved',
  available: 'Available',
  minimumQuantity: 'Minimum',
  maximumQuantity: 'Maximum',

  list: {
    title: 'Inventory',
    empty: 'No products in inventory',
    search: 'Search products',
    filter: 'Filters',
    product: 'Product',
    warehouse: 'Warehouse',
    quantity: 'Quantity',
    available: 'Available',
    reserved: 'Reserved',
    unit: 'Unit',
    minQuantity: 'Min Level',
    maxQuantity: 'Max Level',
    lastUpdated: 'Last Updated',
    belowMinimum: 'Below min level',
    aboveMaximum: 'Above max level',
    onlyAvailable: 'Only available stock'
  },

  movements: {
    title: 'Stock Movements',
    empty: 'No stock movements',
    search: 'Search stock movements',
    filter: 'Filters',
    date: 'Date',
    product: 'Product',
    warehouse: 'Warehouse',
    targetWarehouse: 'Target Warehouse',
    quantity: 'Quantity',
    type: 'Movement Type',
    document: 'Document',
    user: 'User',
    note: 'Note',
    dateRange: 'Date Range',
    fromDate: 'From Date',
    toDate: 'To Date',
    noMovementsFound: 'No stock movements found',
    allWarehouses: 'All warehouses',
    newestFirst: 'Newest first',
    oldestFirst: 'Oldest first',
    sortNewestFirst: 'Show newest first',
    sortOldestFirst: 'Show oldest first',
    refresh: 'Refresh'
  },

  documentTypes: {
    'Raktári bevét': 'Stock Receipt',
    'Raktári kiadás': 'Stock Issue',
    'Raktári átmozgatás': 'Stock Transfer',
    'Korrekció': 'Adjustment',
    'Leltár': 'Inventory',
    'Foglalás': 'Reservation',
    'Foglalás feloldás': 'Reservation Release',
    'Raktárközi átadás': 'Inter-warehouse Transfer',
    'Számla': 'Invoice',
    'Bejövõ számla': 'Incoming Invoice',
    'RECEIPT': 'Receipt Document',
    'TRANSFER': 'Transfer Document'
  },

  movementTypes: {
    STOCK_IN: 'Stock In',
    STOCK_OUT: 'Stock Out',
    STOCK_TRANSFER: 'Transfer',
    STOCK_ADJUSTMENT: 'Adjustment',
    STOCK_INVENTORY: 'Inventory',
    STOCK_RESERVATION: 'Reservation',
    STOCK_RESERVATION_RELEASE: 'Reservation Release',
    BEVÉTELEZÉS: 'Stock In',
    KIADÁS: 'Stock Out',
    ÁTMOZGATÁS: 'Transfer',
    KORREKCIÓ: 'Adjustment',
    ISMERETLEN: 'Unknown',
    stockInShort: 'In',
    stockOutShort: 'Out',
    transferShort: 'Transfer',
    adjustmentShort: 'Adjust',
    inventoryShort: 'Count',
    reservationShort: 'Reserve',
    releaseShort: 'Release'
  },

  actions: {
    stockIn: 'Stock Receipt',
    stockOut: 'Stock Out',
    transfer: 'Inter-warehouse Transfer',
    adjustment: 'Adjustment',
    inventory: 'Inventory',
    reservation: 'Reserve',
    releaseReservation: 'Release Reservation'
  },

  form: {
    title: {
      stockIn: 'New Stock In',
      stockOut: 'New Stock Out',
      transfer: 'Stock Transfer',
      adjustment: 'Stock Adjustment',
      inventory: 'Inventory Count',
      reservation: 'Stock Reservation',
      releaseReservation: 'Release Reservation'
    },
    product: 'Product',
    warehouse: 'Warehouse',
    targetWarehouse: 'Target Warehouse',
    quantity: 'Quantity',
    document: 'Related Document',
    documentNumber: 'Document Number',
    note: 'Note',
    lotNumber: 'Lot Number',
    expiryDate: 'Expiry Date',
    serialNumber: 'Serial Number',
    currentStock: 'Current Stock',
    location: 'Location',
    date: 'Date',
    selectProduct: 'Select a product',
    selectWarehouse: 'Select a warehouse'
  },

  success: {
    stockIn: 'Stock in successfully recorded',
    stockOut: 'Stock out successfully recorded',
    transfer: 'Stock transfer successfully recorded',
    adjustment: 'Stock adjustment successfully recorded',
    inventory: 'Inventory count successfully recorded',
    reservation: 'Stock reservation successfully recorded',
    releaseReservation: 'Reservation release successfully recorded'
  },

  error: {
    insufficientStock: 'Insufficient stock for this operation',
    productNotFound: 'Product not found',
    warehouseNotFound: 'Warehouse not found',
    generic: 'An error occurred during the stock operation'
  },

  report: {
    title: 'Inventory Report',
    totalQuantity: 'Total Quantity',
    availableQuantity: 'Available Quantity',
    reservedQuantity: 'Reserved Quantity',
    warehouseDetails: 'Warehouse Details',
    export: 'Export',
    filter: 'Filter',
    product: 'Product',
    warehouse: 'Warehouse'
  }
}; 